
































import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import { BlockedLocationAutocomplete } from "@scrile/api-provider/dist/api/BlockedLocationsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { getCountryName, getStateName } from "@/lib/i18nHelpers";
import { FormValue, ListField } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseCheckChip from "@/components/BaseCheckChip";
import LocationSearchInput from "@/components/LocationSearchInput";
import ModalView from "@/components/ModalView";
import { languageList } from "@/views/PagePayeeInfo/config";

export default defineComponent({
  name: "PersonalEditLocalization",
  components: { BaseCheckChip, LocationSearchInput, BaseButton, ModalView },
  setup(_, { emit }) {
    const { authUserStrict } = useAuthUser();
    const location = ref<FormValue>("");
    const show = ref(false);
    const showClear = ref(false);
    const personalLocalization = ref<FormValue>({
      localizationCity: "",
      localizationStateCode: "",
      localizationCountryCode: "",
      localizationLanguage: [],
    });

    const checkedLanguages = computed<Record<string, boolean>>(() => {
      if (
        personalLocalization.value &&
        personalLocalization.value.localizationLanguage &&
        personalLocalization.value.localizationLanguage.length
      )
        showClear.value = true;
      else showClear.value = false;
      return languageList.reduce<Record<string, boolean>>((out, item) => {
        out[item.text] = personalLocalization.value
          ? !!personalLocalization.value.localizationLanguage?.includes(item.value)
          : false;
        return out;
      }, {});
    });

    const displayLanguages = computed(() => {
      return languageList
        .filter(item => personalLocalization.value.localizationLanguage.includes(item.value))
        .map(i => i.text)
        .join(", ");
    });
    const setLocation = (value: BlockedLocationAutocomplete) => {
      personalLocalization.value.localizationCity = value.city;
      personalLocalization.value.localizationStateCode = value.stateCode;
      personalLocalization.value.localizationCountryCode = value.countryCode;
    };

    const getData = async () => {
      const response = await providers.UserPublicDataProvider.userPublicInformationFind(authUserStrict.value.id);
      if (response.location.countryCode) {
        location.value += getCountryName(response.location.countryCode);
      }

      if (response.location.stateCode && response.location.countryCode) {
        location.value += `, ${getStateName(response.location.stateCode, response.location.countryCode)}`;
      }

      if (response.location.city) {
        location.value += `, ${response.location.city}`;
      }
      personalLocalization.value.localizationCity = response.location.city;
      personalLocalization.value.localizationStateCode = response.location.stateCode;
      personalLocalization.value.localizationCountryCode = response.location.countryCode;
      personalLocalization.value.localizationLanguage = response.languages || [];
    };

    const saveFields = () => {
      providers.UserPublicDataProvider.userPublicInformationUpdate({
        userId: authUserStrict.value.id,
        location: {
          countryCode: personalLocalization.value.localizationCountryCode,
          stateCode: personalLocalization.value.localizationStateCode || "",
          city: personalLocalization.value.localizationCity || "",
        },
        languages: personalLocalization.value.localizationLanguage,
      });
    };

    watch(personalLocalization.value, () => {
      emit("edit", {
        ...personalLocalization.value,
      });
    });

    const input = (field: ListField, value: boolean) => {
      if (value) {
        personalLocalization.value.localizationLanguage.push(field.value);
      } else {
        personalLocalization.value.localizationLanguage = personalLocalization.value.localizationLanguage.filter(
          (i: string) => i !== field.value
        );
      }
    };

    const save = () => {
      saveFields();
      show.value = false;
    };

    const clear = () => {
      personalLocalization.value.localizationLanguage = [];
    };

    const created = async () => {
      await getData();
    };

    created();

    return {
      location,
      displayLanguages,
      show,
      showClear,
      checkedLanguages,
      languageList,
      setLocation,
      clear,
      input,
      save,
    };
  },
});
